import { Slide } from "react-reveal";
import FaqCard from "../reusables/FaqCard";
import FaqCardList from "../reusables/FaqCardList";
import OtherFAQs from "../reusables/OtherFAQs";

const EcommerceFaqsBody = () => {
  return (
    <section className="faqs section-spacing-100">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head center width-600 margin-auto section-spacing-50 no-padding-top">
              <p className="section-tag boldTitle">FAQS</p>
              <Slide top>
                <h2 className="section-title ntuna-text-fill">
                  Frequently Asked Questions
                </h2>
              </Slide>
            </div>
            <div className="section-body">
              <ul className="faqs-container width-600 margin-auto">
                <FaqCardList faq="How do I know if my business needs an e-commerce website/app?">
                  <p>If you want to:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Sell beyond your physical location</span>
                    </li>
                    <li>
                      <span>Accept payments online</span>
                    </li>
                    <li>
                      <span>Reach more customers</span>
                    </li>
                    <li>
                      <span>Operate 24/7</span>
                    </li>
                  </ul>
                  <p>
                    Then an e-commerce system is essential. We help you
                    structure it based on your business model.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Can I accept mobile money and card payments on my store?">
                  <p>Yes. We can integrate:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Mobile money payments</span>
                    </li>
                    <li>
                      <span>Visa & Mastercard payments</span>
                    </li>
                    <li>
                      <span>POS systems for physical transactions</span>
                    </li>
                  </ul>
                  <p>
                    Your customers can pay using the method most convenient to
                    them.
                  </p>
                </FaqCardList>
                <FaqCardList faq="How secure are online payments on the online store?">
                  <p>Very secure. We implement:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>SSL encryption</span>
                    </li>
                    <li>
                      <span>Secure payment gateways</span>
                    </li>
                    <li>
                      <span>Secure payment gateways</span>
                    </li>
                    <li>
                      <span>Data protection systems</span>
                    </li>
                  </ul>
                  <p>
                    Your customers’ payment information is safe and protected.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will I be able to manage products and orders myself?">
                  <p>Yes. You’ll have a dashboard to:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Add/edit products</span>
                    </li>
                    <li>
                      <span>Track inventory</span>
                    </li>
                    <li>
                      <span>Manage orders</span>
                    </li>
                    <li>
                      <span>View customer activity</span>
                    </li>
                  </ul>
                  <p>We also train you and your team on how to use it.</p>
                </FaqCardList>
                <FaqCardList faq="What happens when a customer places an order?">
                  <p>The system automatically:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>You can add new features anytime</span>
                    </li>
                    <li>
                      <span>Handle more users and data</span>
                    </li>
                    <li>
                      <span>Expand without rebuilding from scratch</span>
                    </li>
                  </ul>
                </FaqCardList>
                <FaqCardList faq="Is the system secure?">
                  <p>Yes. We implement:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Records the order</span>
                    </li>
                    <li>
                      <span>Notifies you and the customer</span>
                    </li>
                    <li>
                      <span>Generates an invoice/receipt</span>
                    </li>
                    <li>
                      <span>Updates order status</span>
                    </li>
                  </ul>
                  <p>You then process and deliver the order efficiently.</p>
                </FaqCardList>
                <FaqCardList faq="Will my store work well on mobile phones?">
                  <p>Yes. All web-based stores are:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Mobile-responsive</span>
                    </li>
                    <li>
                      <span>Optimized for fast performance</span>
                    </li>
                    <li>
                      <span>Easy to use on all devices</span>
                    </li>
                  </ul>
                  <p>Most of your customers will shop via mobile.</p>
                </FaqCardList>
                <FaqCardList faq="How long does it take to build an e-commerce website?">
                  <p>It depends on complexity:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Simple store: 2–3 weeks</span>
                    </li>
                    <li>
                      <span>Standard store: 3–6 weeks</span>
                    </li>
                    <li>
                      <span>Advanced systems: 6+ weeks</span>
                    </li>
                  </ul>
                  <p>You get a clear timeline before we start.</p>
                </FaqCardList>
                <FaqCardList faq="Can I offer discounts, promotions, or coupons?">
                  <p>Yes. We can set up:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Discount codes</span>
                    </li>
                    <li>
                      <span>Promotions</span>
                    </li>
                    <li>
                      <span>Sales campaigns</span>
                    </li>
                  </ul>
                  <p>This helps increase conversions and sales.</p>
                </FaqCardList>
                <FaqCardList faq="Will I be able to track my sales and performance?">
                  <p>Yes. You’ll have access to:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Sales reports</span>
                    </li>
                    <li>
                      <span>Customer insights</span>
                    </li>
                    <li>
                      <span>Product performance data</span>
                    </li>
                    <li>
                      <span>Traffic analytics</span>
                    </li>
                  </ul>
                  <p>
                    This helps you make better business decisions based on real
                    and real-time data.
                  </p>
                </FaqCardList>
                <FaqCardList faq="What if I already have a business and want to move online?">
                  <p>We handle that.</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Product migration</span>
                    </li>
                    <li>
                      <span>System setup</span>
                    </li>
                    <li>
                      <span>Optimization for online selling</span>
                    </li>
                  </ul>
                  <p>We help you transition smoothly.</p>
                </FaqCardList>
                <FaqCardList faq="Can the store grow as my business expands?">
                  <p>Yes. Your online store is built to:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Handle more products</span>
                    </li>
                    <li>
                      <span>Support more customers</span>
                    </li>
                    <li>
                      <span>Add new features anytime</span>
                    </li>
                  </ul>
                  <p>No need to rebuild later.</p>
                </FaqCardList>
                <FaqCardList faq="How much does building an online store cost?">
                  <p>Costs depend on:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Store complexity</span>
                    </li>
                    <li>
                      <span>Features required</span>
                    </li>
                    <li>
                      <span>Integrations needed</span>
                    </li>
                  </ul>
                  <p>
                    We provide a custom quote after understanding your needs.
                  </p>
                </FaqCardList>
                <FaqCardList faq="How do I/we get started?">
                  <p>
                    Simply{" "}
                    <a
                      href="/contacts"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      contact us
                    </a>{" "}
                    or book a{" "}
                    <a href="/#" target="_blank" rel="noopener noreferrer">
                      consultation
                    </a>
                    . We’ll:
                  </p>
                  <ul className="faq-olist">
                    <li>
                      <span>Understand your needs</span>
                    </li>
                    <li>
                      <span>Features required</span>
                    </li>
                    <li>
                      <span>Define store requirements</span>
                    </li>
                    <li>
                      <span>Propose a solution and timeline</span>
                    </li>
                    <li>
                      <span>Agree on fee so you can make initial deposit</span>
                    </li>
                    <li>
                      <span>Begin development</span>
                    </li>
                  </ul>
                </FaqCardList>

                <FaqCard
                  faq="Do you offer payment plans?"
                  answer="Yes. We offer flexible payment plans to make it easier for clients to invest in the efficiency and growth of their businesses and institutions."
                />
              </ul>
            </div>
            <OtherFAQs />
          </div>
        </div>
      </div>
    </section>
  );
};

export default EcommerceFaqsBody;
